import api from './Api'; // Adjust the path based on your project structure

const BASE_URL = 'auth/';

export default {
  checkEmailExists: (email) => {
    return api.get(`${BASE_URL}check-email-exists`, { params: { email } });
  },
  register: (userPayload, signatureImage) => {
    // Structure the request body to match the endpoint
    const requestBody = {
      userPayload,
      signatureImage
    };

    return api.post(`${BASE_URL}register`, requestBody);
  },
  confirmEmail: (token) => {
    return api.post(`${BASE_URL}confirm-email`, { token });
  },
  login: (creds) => {
    return api.post(`${BASE_URL}login`, creds);
  },
  fetchUser: () => {
    return api.get(BASE_URL).catch((ex) => console.log('Error fetching user:', ex));
  },
  logout: () => {
    return api.delete(BASE_URL);
  },
  // Change password method
  changePassword: (currentPassword, newPassword) => {
    return api.post(`${BASE_URL}changePassword`, {
      currentPassword,
      newPassword
    });
  },
  forgotPassword: (email) => {
    return api.post(`${BASE_URL}forgotPassword`, {
      email
    });
  },
  resetPassword: (token, newPassword) => {
    return api.post(`${BASE_URL}/resetPassword/${token}`, { newPassword });
  },
  loginAsPublisher: (userId) => {
    return api.post(`${BASE_URL}users/${userId}/virtual-login`);
  },
  backToAdmin: () => {
    return api.post(`${BASE_URL}back-to-admin`);
  },
  signTcs: (userId, representativeName, companyName, signatureImage) => {
    // Structure the request body to match the endpoint
    const requestBody = {
      userId,
      representativeName,
      companyName,
      signatureImage
    };

    return api.post(`${BASE_URL}sign-tcs`, requestBody);
  },
}
